import { render } from "./LeftPanel.vue?vue&type=template&id=19c2b97c&scoped=true"
import script from "./LeftPanel.vue?vue&type=script&lang=js"
export * from "./LeftPanel.vue?vue&type=script&lang=js"

import "./LeftPanel.vue?vue&type=style&index=0&id=19c2b97c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c2b97c"]])

export default __exports__